import { Injectable, signal } from '@angular/core';

// Lets any component (header search button, keyboard shortcut, etc.) trigger the
// single app-root ic-command-palette instance without a direct reference to it.
@Injectable({ providedIn: 'root' })
export class CommandPaletteService {
  readonly isOpen = signal(false);

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }

  toggle(): void {
    this.isOpen.update((open) => !open);
  }
}
